(function($){
	OH.settings.vueControl = (function(){
		var control = new Object();
    var deviceSP = OH.browserInfo.isiOS || OH.browserInfo.isAndroid;
    var deviceSPMediaQuery = window.matchMedia('(max-width:600px)').matches;

    /**
     * データを全表示
     * 検索後は非活性クラスを付与
     * 例 レストラン一覧 での非活性
     */
     control.inactiveFilter = function($parent){
 			var vue;
      var easySelect = $parent.data('easySelect');
 			var currentData = null;
 			var $mores = $parent.find('[data-rendering-role="more"]');
 			var $resets = $parent.find('[data-rendering-role="reset"]');
 			var $trigger = $parent.find('[data-rendering-trigger]');
 			var adjustType = $parent.attr("data-adjust-type");
 			var oneviewlength = $parent.attr("data-rendering-unit") - 0 || 10;
 			var currentViewLength = oneviewlength;
 			var renderingName = $parent.attr("data-rendering-name");
 			var define = !renderingName ? {} : OH.settings.vueDefine.rendering[renderingName];
 			var renderingFirstView = $parent.attr("data-rendering-firstview") == "true" ? true : false;
 			var atfirst = !renderingFirstView;
 			var lastSearched = null;
 			var defaultModel = (function(name){
 				var base = !name ? {} : OH.settings.vueDefine.models[name];
 				base.indexes = null;
 				base.atfirst = atfirst;
 				return base;
 			})(renderingName);
 			var listRefiners = !renderingName ? {} : OH.settings.vueDefine.refiners[renderingName];
 			var watchTargets = (function(){
 				var targets = new Array();
 				$parent.find('[data-rendering-watch]').each(function(){
 					var t = $(this).attr('data-rendering-watch');
 					if(!!t && targets.indexOf(t) < 0){
 						targets.push(t);
 					}
 				});
 				return targets;
 			})();
 			var lastOperation = new Date().getTime();
 			var operationLock = false;

 			var serial = (function(){
 				if(!control.thumbnail.serial){
 					control.thumbnail.serial = 0;
 				}
 				return ++control.thumbnail.serial - 0;
 			})();

 			if(!!adjustType){
 				OH.onResizeTasks.append("vuecontrol_refined_" + serial, function(){
 					OH.settings.heightControl[adjustType]($parent);
 				});
 			}

 			var optionMethods = {
 				enableView : function(){
 					vue.setModel("atfirst", false);
 				}
 			};

 			vue = new OH.VueRenderer($parent.get(0), {
 				define : define,
 				model : defaultModel,
 				methods : optionMethods,
 				filters : OH.settings.vueDefine.additionalFilters
 			});

 			var modelSelected = function(){
 				var models = vue.getModel();
 				for(var i=0; i<watchTargets.length; i++){
 					if(OH.settings.vueDefine.modified(renderingName, watchTargets[i], models[watchTargets[i]])){
 						return true;
 					}
 				}
 				return false;
 			};

 			var toggleMore = function(){
 				var atfirst = (vue.getModel())["atfirst"];
 				$mores.each(function(){
 					($(this)[(!atfirst && !!currentData && currentViewLength < currentData.length) ? "show" : "hide"])();
 				});
 				$resets.each(function(){
 					($(this)[ modelSelected() ? "show" : "hide"])();
 				});
 			};
 			var showData = function(){

 				var models = vue.getModel();
 				if(!currentData){
 					rerender();
 				}

 				if(!lastSearched){
 					lastSearched = {};
 				}

 				for(var i=0; i<watchTargets.length; i++){
 					lastSearched[watchTargets[i]] = models[watchTargets[i]];
 				}
 				vue.setModel("cansearch", false);
 				// vue.setModel("cansearch", true);

 				vue.setModel("indexes", (!currentData.length) ? null : {
 					begin : 1,
 					end : Math.min(currentViewLength, currentData.length),
 					length : currentData.length
 				});
 				vue.setData(currentData.slice(0, currentViewLength));
 				vue.setModel("atfirst", false);

 				var stock = new Object();
 				for(var i=0; i<watchTargets.length; i++){
 					stock[watchTargets[i]] = models[watchTargets[i]] + "";
 				}
 				OH.setSession(OH.storageKeys.refineValues, JSON.stringify(stock));
 			};

 			var hasModified = function(){

 				if(!lastSearched){
 					return true;
 				}

 				var models = vue.getModel();
         
 				for(var i=0; i<watchTargets.length; i++){
 					if(lastSearched[watchTargets[i]] !== models[watchTargets[i]]){
 						return true;
 					}
 				}
 				return false;
 			}

 			var setData = function(){
 				var modified = hasModified();

 				vue.setModel("cansearch", true);

 				vue.setCallback(function(){
 					var calmdown = window.setInterval(function(){
 						if(!operationLock && new Date().getTime() > lastOperation + 333){
 							window.clearInterval(calmdown);
 							OH.settings.vueDefine.afterRender($parent, (!!$trigger && $trigger.length) ? $trigger : null);
 						}
 					}, 33);

 					if(!!adjustType){
 						window.setTimeout(function(){
 							OH.settings.heightControl[adjustType]($parent);
 						}, 111);
 					}
 					vue.getObserver().stop();
 				});

 				// iosでのmoreの暫定対応
 				currentViewLength = currentData.length;

 				toggleMore();

 				if(renderingFirstView){
 					showData();
 				}
 			};


 			var mountData2model = function(data){
 				currentData = data;
 				setData();
 			};

 			var increaseView = function(event){
 				if(!!event){
 					event.preventDefault();
 				}
 				currentViewLength += oneviewlength;
 				setData();
 			};

      var resetView = function(event){
				if(!!event){
					event.preventDefault();
				}
				for(var i=0; i<watchTargets.length; i++){
					lastSearched[watchTargets[i]] = OH.settings.vueDefine.defaultValue(renderingName, watchTargets[i]);
					vue.setModel(watchTargets[i], OH.settings.vueDefine.defaultValue(renderingName, watchTargets[i]));
				}
				// vue.setModel("atfirst", atfirst);
				// setData();
        rerender();
				showData();
				toggleMore();
				OH.setSession(OH.storageKeys.refineValues, '');
			};
       
       
       /**
        * incしている data-refine-defineをObject化
        */
 			var parsedData = OH.settings.parserDefine.vueData($parent.attr('data-rendering-resource'));

 			var rerender = function(firstQuery){

 				if(!!firstQuery){
 					OH.requireVueLoadScroll = true;
 				}
 				firstQuery = (!!firstQuery && !!firstQuery.split && typeof firstQuery.split == "function") ? firstQuery.split("=") : ["", ""];
 				firstQuery = OH.settings.vueDefine.queryFilter(firstQuery);

 				var refineProp = firstQuery[0];
 				var refineValue = firstQuery[1];

 				var models = vue.getModel();
         var active = vue.getActive(false);
 				if(!!refineProp){
 					models[refineProp] = refineValue;
 				}
 				var data = vue.getData();
         //ここでdataに検索後のobject入れてる
 				for(var m in models){
 					data = !!listRefiners[m] ? listRefiners[m](data, models[m], parsedData.define) : data;
 				}
 				currentViewLength = oneviewlength;
 				mountData2model(data);

 				if(!!refineProp){
 					toggleMore();
 				}
 			};
      
      /**
       * inActiveClassのリムーブ
       */
      var setSeach = function(catsVal,optsVal){
        var $targetElm = $('[data-items]');
        $targetElm.each(function(){
          var macthCategory = $(this).data('categoryId').split(',');
          var macthOption = $(this).data('optionId').split(',');
          var catMatch = (catsVal === '_') ? true : macthCategory.indexOf(catsVal);
          var optMatch = (optsVal === '_') ? true : macthOption.indexOf(optsVal);
          var $addTarget = $('.l-shop_list__item', this);
          // $addTarget.addClass('is-inactiveLink');
          if(catMatch  != -1 && optMatch != -1){
            $addTarget.removeClass('is-inactiveLink');
            $addTarget.off('click')
            // return;
          } else {
            $addTarget.addClass('is-inactiveLink');
            $addTarget.on('click',function(eventLink){
              eventLink.preventDefault();
            });
          }
        });
      };

      
 			var resetSeach = function(){
        $('[data-category-id]').each(function(){
          $(this).find('.l-shop_list__item').removeClass('is-inactiveLink');
        });
        $trigger.eq(0).find('option:first').prop('selected',true);
        $trigger.eq(1).find('option:first').prop('selected',true);
        //easySelectはPCのみ有効
        if(easySelect == true && !deviceSPMediaQuery){
          var downIcon = '<svg class="c-icon is-xsmall is-afterFit is-restaurant_drop"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#angle-down"></use></svg>'
          $('.easy-select-0').find('.esb-displayer').html($trigger.eq(0).find('option:first').text() + downIcon);
          $('.easy-select-1').find('.esb-displayer').html($trigger.eq(1).find('option:first').text() + downIcon);
          $('.esb-item').each(function(){
            $(this).removeClass('current_option_item');
          });
        }
        toggleMore();
 			};

 			var hashRefiner = function(){
 				var hash = (window.location.hash.length > 0 && window.location.hash.indexOf("#") == 0 ) ? window.location.hash.slice("#".length) : "";
 				if(hash.indexOf(OH.settings.vueDefine.hashPrefix) < 0){

 					if(!OH.locationHistory.backed){
 						return false;
 					}
 					var restorValues  = (function(){
 						var values = OH.getSession(OH.storageKeys.refineValues);
 						try{
 							values = JSON.parse(values);
 						}
 						catch(e){
 							values = null
 						}
 						return values;
 					})();

 					if(!restorValues){
 						return false;
 					}
 					lastSearched = restorValues;

 					return function(){
 						for(var i=0; i<watchTargets.length; i++){
 							if(!restorValues[watchTargets[i]]){
 								continue;
 							}
 							vue.setModel(watchTargets[i], restorValues[watchTargets[i]]);
 						}
 						// vue.setModel("atfirst", false);
 						rerender();
 						// showData();
 					};
 				}
 				return function(){
 					rerender(hash.slice(OH.settings.vueDefine.hashPrefix.length));
 				};
 			};

 			var firstRefine = hashRefiner();

 			$(window).on("hashchange", function(){
 				var task = hashRefiner();
 				if(!!task && typeof task == "function"){
 					task();
 				}
 			});


 			vue.init(parsedData, !!firstRefine ? firstRefine : atfirst ? toggleMore : resetSeach);
       
       //ここでdata-refine-listをjson parse
 			if(!!OH.settings.vueDefine.firstTasks[renderingName]){
 				OH.settings.vueDefine.firstTasks[renderingName](parsedData.result, $parent);
 			}

 			var maySearchedInit = !lastSearched;

 			lastSearched = maySearchedInit ? {} : lastSearched;

 			for(var i=0; i<watchTargets.length; i++){
 				if(maySearchedInit){
 					lastSearched[watchTargets[i]] = OH.settings.vueDefine.defaultValue(renderingName, watchTargets[i]);
 				}
 				vue.setWatcher(watchTargets[i], function(){
 					rerender();
 				});
 			}
 			vue.setModel("cansearch", true);

 			$parent.find('select').each(function(){
 				$(this).on("blur", function(){
 					operationLock = false;
 					lastOperation = new Date().getTime();
 				});
 				$(this).on("focus", function(){
 					operationLock = true;
 				});
 			});


       // windowが読み込まれたらまず表示
      $(window).on('load',showData);
 			$trigger.on("change", function(event){
 				event.preventDefault();
        if(!deviceSPMediaQuery){
          var cats = $trigger.eq(0).find('option:selected').val().replace(/^(_)(.+)$/,'$2');
          var opts = $trigger.eq(1).find('option:selected').val().replace(/^(_)(.+)$/,'$2');
          setSeach(cats,opts);
          $resets.show();
        }else{
          rerender();
          showData();
        }
 			});
 			// $trigger.change(showData);

 			$mores.each(function(){
 				$(this).on("click change", increaseView);
 			});

 			$resets.each(function(){
        $(this).on("click", function(){
          if(!deviceSPMediaQuery){
            resetSeach();
          }else {
            resetView();
          }
        });
 			});
 		};


    /**
     * 検索後に該当データのみ表示
     *
     */
		control.thumbnail = function($parent){
			var vue;
			var currentData = null;
			var $mores = $parent.find('[data-rendering-role="more"]');
			var $resets = $parent.find('[data-rendering-role="reset"]');
			var $trigger = $parent.find('[data-rendering-trigger]').eq(0);
			var $trigger = $parent.find('[data-rendering-trigger]');
			var adjustType = $parent.attr("data-adjust-type");
			var oneviewlength = $parent.attr("data-rendering-unit") - 0 || 10;
			var currentViewLength = oneviewlength;
			var renderingName = $parent.attr("data-rendering-name");
			var define = !renderingName ? {} : OH.settings.vueDefine.rendering[renderingName];
			var renderingFirstView = $parent.attr("data-rendering-firstview") == "true" ? true : false;
			var atfirst = !renderingFirstView;
			var lastSearched = null;
			var defaultModel = (function(name){
				var base = !name ? {} : OH.settings.vueDefine.models[name];
				base.indexes = null;
				base.atfirst = atfirst;
				return base;
			})(renderingName);
			var listRefiners = !renderingName ? {} : OH.settings.vueDefine.refiners[renderingName];
			var watchTargets = (function(){
				var targets = new Array();
				$parent.find('[data-rendering-watch]').each(function(){
					var t = $(this).attr('data-rendering-watch');
					if(!!t && targets.indexOf(t) < 0){
						targets.push(t);
					}
				});
				return targets;
			})();
			var lastOperation = new Date().getTime();
			var operationLock = false;

			var serial = (function(){
				if(!control.thumbnail.serial){
					control.thumbnail.serial = 0;
				}
				return ++control.thumbnail.serial - 0;
			})();

			if(!!adjustType){
				OH.onResizeTasks.append("vuecontrol_refined_" + serial, function(){
					OH.settings.heightControl[adjustType]($parent);
				});
			}

			var optionMethods = {
				enableView : function(){
					vue.setModel("atfirst", false);
				}
			};

			vue = new OH.VueRenderer($parent.get(0), {
				define : define,
        avtive: true,
				model : defaultModel,
				methods : optionMethods,
				filters : OH.settings.vueDefine.additionalFilters
			});

			var modelSelected = function(){
				var models = vue.getModel();
				for(var i=0; i<watchTargets.length; i++){
					if(OH.settings.vueDefine.modified(renderingName, watchTargets[i], models[watchTargets[i]])){
						return true;
					}
				}
				return false;
			};

			var toggleMore = function(){
				var atfirst = (vue.getModel())["atfirst"];
				$mores.each(function(){
					($(this)[(!atfirst && !!currentData && currentViewLength < currentData.length) ? "show" : "hide"])();
				});
				$resets.each(function(){
					($(this)[ modelSelected() ? "show" : "hide"])();
				});
			};
			var showData = function(){

				var models = vue.getModel();
				if(!currentData){
					rerender();
				}

				if(!lastSearched){
					lastSearched = {};
				}

				for(var i=0; i<watchTargets.length; i++){
					lastSearched[watchTargets[i]] = models[watchTargets[i]];
				}
				vue.setModel("cansearch", false);
				// vue.setModel("cansearch", true);

				vue.setModel("indexes", (!currentData.length) ? null : {
					begin : 1,
					end : Math.min(currentViewLength, currentData.length),
					length : currentData.length
				});
				vue.setData(currentData.slice(0, currentViewLength));
				vue.setModel("atfirst", false);

				var stock = new Object();
				for(var i=0; i<watchTargets.length; i++){
					stock[watchTargets[i]] = models[watchTargets[i]] + "";
				}
				OH.setSession(OH.storageKeys.refineValues, JSON.stringify(stock));
			};

			var hasModified = function(){

				if(!lastSearched){
					return true;
				}

				var models = vue.getModel();
        
				for(var i=0; i<watchTargets.length; i++){
					if(lastSearched[watchTargets[i]] !== models[watchTargets[i]]){
						return true;
					}
				}
				return false;
			}

			var setData = function(){
				var modified = hasModified();

				// vue.setModel("cansearch", modified);
				vue.setModel("cansearch", true);

				vue.setCallback(function(){
					var calmdown = window.setInterval(function(){
						if(!operationLock && new Date().getTime() > lastOperation + 333){
							window.clearInterval(calmdown);
							OH.settings.vueDefine.afterRender($parent, (!!$trigger && $trigger.length) ? $trigger : null);
						}
					}, 33);

					if(!!adjustType){
						window.setTimeout(function(){
							OH.settings.heightControl[adjustType]($parent);
						}, 111);
					}
					vue.getObserver().stop();
				});

				// iosでのmoreの暫定対応
				currentViewLength = currentData.length;

				toggleMore();

				if(renderingFirstView){
					showData();
				}
			};


			var mountData2model = function(data){
				currentData = data;
				setData();
			};

			var increaseView = function(event){
				if(!!event){
					event.preventDefault();
				}
				currentViewLength += oneviewlength;
				setData();
			};

			var resetView = function(event){
				if(!!event){
					event.preventDefault();
				}
				for(var i=0; i<watchTargets.length; i++){
					lastSearched[watchTargets[i]] = OH.settings.vueDefine.defaultValue(renderingName, watchTargets[i]);
					vue.setModel(watchTargets[i], OH.settings.vueDefine.defaultValue(renderingName, watchTargets[i]));
				}
				// vue.setModel("atfirst", atfirst);
				// setData();
        rerender();
				showData();
				toggleMore();
				OH.setSession(OH.storageKeys.refineValues, '');
			};
      
      
      /**
       * incしている data-refine-defineをObject化
       */
			var parsedData = OH.settings.parserDefine.vueData($parent.attr('data-rendering-resource'));

			var rerender = function(firstQuery){

				if(!!firstQuery){
					OH.requireVueLoadScroll = true;
				}
				firstQuery = (!!firstQuery && !!firstQuery.split && typeof firstQuery.split == "function") ? firstQuery.split("=") : ["", ""];
				firstQuery = OH.settings.vueDefine.queryFilter(firstQuery);

				var refineProp = firstQuery[0];
				var refineValue = firstQuery[1];

				var models = vue.getModel();
        var active = vue.getActive(false);
				if(!!refineProp){
					models[refineProp] = refineValue;
				}
				var data = vue.getData();
        //ここでdataに検索後のobject入れてる
				for(var m in models){
					data = !!listRefiners[m] ? listRefiners[m](data, models[m], parsedData.define) : data;
				}
				currentViewLength = oneviewlength;
				mountData2model(data);

				if(!!refineProp){
					toggleMore();
				}
			};

			var hashRefiner = function(){
				var hash = (window.location.hash.length > 0 && window.location.hash.indexOf("#") == 0 ) ? window.location.hash.slice("#".length) : "";
				if(hash.indexOf(OH.settings.vueDefine.hashPrefix) < 0){

					if(!OH.locationHistory.backed){
						return false;
					}
					var restorValues  = (function(){
						var values = OH.getSession(OH.storageKeys.refineValues);
						try{
							values = JSON.parse(values);
						}
						catch(e){
							values = null
						}
						return values;
					})();

					if(!restorValues){
						return false;
					}
					lastSearched = restorValues;

					return function(){
						for(var i=0; i<watchTargets.length; i++){
							if(!restorValues[watchTargets[i]]){
								continue;
							}
							vue.setModel(watchTargets[i], restorValues[watchTargets[i]]);
						}
						// vue.setModel("atfirst", false);
						rerender();
						// showData();
					};
				}
				return function(){
					rerender(hash.slice(OH.settings.vueDefine.hashPrefix.length));
				};
			};

			var firstRefine = hashRefiner();

			$(window).on("hashchange", function(){
				var task = hashRefiner();
				if(!!task && typeof task == "function"){
					task();
				}
			});


			vue.init(parsedData, !!firstRefine ? firstRefine : atfirst ? toggleMore : rerender);
      
      //ここでdata-refine-listをjson parse
			if(!!OH.settings.vueDefine.firstTasks[renderingName]){
				OH.settings.vueDefine.firstTasks[renderingName](parsedData.result, $parent);
			}

			var maySearchedInit = !lastSearched;

			lastSearched = maySearchedInit ? {} : lastSearched;

			for(var i=0; i<watchTargets.length; i++){
				if(maySearchedInit){
					lastSearched[watchTargets[i]] = OH.settings.vueDefine.defaultValue(renderingName, watchTargets[i]);
				}
				vue.setWatcher(watchTargets[i], function(){
					rerender();
				});
			}
			vue.setModel("cansearch", true);

			$parent.find('select').each(function(){
				$(this).on("blur", function(){
					operationLock = false;
					lastOperation = new Date().getTime();
				});
				$(this).on("focus", function(){
					operationLock = true;
				});
			});


      // windowが読み込まれたらまず表示
      $(window).on('load',showData);
			$trigger.on("change", function(event){
				event.preventDefault();
		     //	mountData2model(vue.getData());
        rerender();
				showData();
			});
			// $trigger.change(showData);

			$mores.each(function(){
				$(this).on("click change", increaseView);
			});

			$resets.each(function(){
				$(this).on("click", resetView);
			});
		};

		return control;
	})();
})(jQuery);
